import { useNavigate } from 'react-router-dom';
import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function TicketComplete({ onClose }: ModalProps) {
  const navigate = useNavigate();
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>입장권 예매 완료</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>
            2025 목포해상W쇼에
            <br /> 많은 관심을 가져주셔서 감사합니다.
          </S.Summary>
          <S.Summary>
            입장권은 입력하신 번호로
            <br /> 4월 22일(화) 이후 문자 발송됩니다.
          </S.Summary>
          <S.Summary>
            입장권과 함께 전송될
            <br /> ‘입장권 예매 주의사항’을
            <br /> 필히 숙지해주세요.
          </S.Summary>
          <S.AskMethod>
            *입장권 관련 문의: <br />
            <a
              href="https://pf.kakao.com/_Ixexiwn"
              style={{ textDecoration: 'underline' }}
            >
              https://pf.kakao.com/_Ixexiwn
            </a>
          </S.AskMethod>
        </S.ModalContent>
        <S.CloseButton
          type="button"
          onClick={() => {
            onClose();
            navigate('/');
          }}
        >
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
